import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import ClientsList from '../../components/clients/ClientsList';
import ClientForm from '../../components/clients/ClientForm';
import ClientDetails from '../../components/clients/ClientDetails';

const ClientsManagement = () => {
  return (
    <div className="space-y-6">
      <Routes>
        <Route index element={<ClientsList />} />
        <Route path="new" element={<ClientForm />} />
        <Route path=":id" element={<ClientDetails />} />
        <Route path=":id/edit" element={<ClientForm />} />
      </Routes>
    </div>
  );
};

export default ClientsManagement;